import { resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<main class=\"site-content\"><div class=\"section-content\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-8 ml-md-auto mr-md-auto\"><h1 class=\"text-center\">Thanks!</h1><h3 class=\"text-center mb-3\">Thanks for your purchase of a gift voucher.</h3><h4 class=\"text-center mb-3\">Now that your payment is processed it can take up to 24 hours to create your unique voucher code, and this will be sent to the email address provided via the payment process.</h4></div></div></div></div></main>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_page_header, {
      image: "ladder",
      title: "Booking"
    }),
    _hoisted_1
  ]))
}